import { render, staticRenderFns } from "./loginavite.vue?vue&type=template&id=007006bb&scoped=true&"
import script from "./loginavite.vue?vue&type=script&lang=js&"
export * from "./loginavite.vue?vue&type=script&lang=js&"
import style0 from "./loginavite.vue?vue&type=style&index=0&id=007006bb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007006bb",
  null
  
)

export default component.exports